import React from "react";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";

const TenantInsuranceCoverageRightBar = [

    RightBarMethod(
        " ",
        "",
        <i className=""></i>,
        [
          RightBarMethod("", "", "", "", ""),
        ]
      ),

  ];

function TenantInsuranceCoverage() {
  return (
    <>
      <div>
        <PageHeading heading="Pricing Metrics" />
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={TenantInsuranceCoverageRightBar} />
      </div>
    </>
  );
}

export default TenantInsuranceCoverage;